import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';

export const splashPlatformGuard: CanActivateFn = () => {
  if (Capacitor.isNativePlatform()) {
    return true;
  }

  return inject(Router).createUrlTree(['/login']);
};
